module.exports = __webpack_public_path__ + "static/bg_back_card-d6d28811de872e3f04c08c1533f5db05.png";